import React, { useState } from 'react';
import { CalendarIcon, ClockIcon, LaptopIcon, AlertCircleIcon, ArrowDownIcon } from 'lucide-react';
import { RegistrationModal } from './RegistrationModal';
interface CTASectionProps {
  setShowThankYou: (show: boolean) => void;
}
export function CTASection({
  setShowThankYou
}: CTASectionProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSuccess = () => {
    setIsModalOpen(false);
    setShowThankYou(true);
  };
  return <>
      <section className="text-center" data-id="element-77">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 lg:gap-8 mb-8 md:mb-12 lg:mb-16" data-id="element-78">
          <div className="bg-red-900 bg-opacity-30 p-6 md:p-8 lg:p-10 rounded-xl md:rounded-2xl flex flex-col items-center transition-transform hover:scale-105" data-id="element-79">
            <CalendarIcon className="h-10 w-10 md:h-12 md:w-12 text-red-400 mb-4 md:mb-6" data-id="element-80" />
            <p className="text-base md:text-lg lg:text-xl font-medium leading-relaxed" data-id="element-81">
              <span className="block font-bold text-xl md:text-2xl mb-2" data-id="element-82">
                Martes
              </span>
              6 de enero
            </p>
          </div>
          <div className="bg-red-900 bg-opacity-30 p-6 md:p-8 lg:p-10 rounded-xl md:rounded-2xl flex flex-col items-center transition-transform hover:scale-105" data-id="element-83">
            <ClockIcon className="h-10 w-10 md:h-12 md:w-12 text-red-400 mb-4 md:mb-6" data-id="element-84" />
            <p className="text-base md:text-lg lg:text-xl font-medium leading-relaxed" data-id="element-85">
              <span className="block font-bold text-xl md:text-2xl mb-2" data-id="element-86">
                Hora
              </span>
              7:00 PM (Hora del Este)
            </p>
          </div>
          <div className="bg-red-900 bg-opacity-30 p-6 md:p-8 lg:p-10 rounded-xl md:rounded-2xl flex flex-col items-center transition-transform hover:scale-105" data-id="element-87">
            <LaptopIcon className="h-10 w-10 md:h-12 md:w-12 text-red-400 mb-4 md:mb-6" data-id="element-88" />
            <p className="text-base md:text-lg lg:text-xl font-medium leading-relaxed" data-id="element-89">
              <span className="block font-bold text-xl md:text-2xl mb-2" data-id="element-90">
                Formato
              </span>
              100% Online y en vivo
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center space-y-6 md:space-y-8" data-id="element-91">
          <div className="flex items-center px-4" data-id="element-92">
            <AlertCircleIcon className="h-6 w-6 md:h-7 md:w-7 text-yellow-500 mr-2 md:mr-3 flex-shrink-0" data-id="element-93" />
            <p className="text-lg sm:text-xl md:text-2xl font-semibold text-yellow-300" data-id="element-94">
              Los cupos son limitados.
            </p>
          </div>
          <div className="flex items-center px-4" data-id="element-95">
            <ArrowDownIcon className="h-6 w-6 md:h-7 md:w-7 text-white mr-2 md:mr-3 flex-shrink-0" data-id="element-96" />
            <p className="text-lg sm:text-xl md:text-2xl" data-id="element-97">
              Reserva tu lugar gratis ahora
            </p>
          </div>
          <div className="w-full max-w-3xl px-4 mx-auto" data-id="element-98">
            <button onClick={() => setIsModalOpen(true)} className="w-full bg-red-600 hover:bg-red-700 active:bg-red-800 text-white text-lg sm:text-xl md:text-2xl font-bold py-4 md:py-5 px-8 md:px-12 shadow-2xl transform hover:scale-105 active:scale-95 transition-all duration-300 flex items-center justify-center touch-manipulation" data-id="element-99">
              RESERVA TU LUGAR GRATIS
              <span className="ml-2 md:ml-3 text-xl md:text-2xl" data-id="element-100">→</span>
            </button>
          </div>
        </div>
      </section>
      <RegistrationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSuccess={handleSuccess} data-id="element-101" />
    </>;
}